import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Stats from './components/Stats';
import About from './components/About';
import Band from './components/Band';
import Setlist from './components/Setlist';
import Gallery from './components/Gallery';
import Dates from './components/Dates';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App bg-[#f5efe7] text-[#1a1a1a] font-sans">
      <Header />
      <main>
        <Hero />
        <Stats />
        <About />
        <Band />
        <Setlist />
        <Gallery />
        <Dates />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
